import {
  standardTubeRoute,
  dnaPlatesRoute,
  fastDuplexOligosRoute,
  sirnaRoute,
  kicqStartRoute,
  kicqstartPrimersRoute,
  kicqstartGeneArrayRoute,
  orfRoute,
  shrnaRoute,
  crisprgrnaRoute,
  simpleantiseraRoute,
  antiseraRoute,
  NgsoRoute,
} from '@src/routes'
import messages, { Message } from '@configurator-messages'
import getConfig from 'next/config'

export interface Products {
  title: string
  displayName: Message
  description?: Message
  url: any
  continueButtonUrl: any
  productCompany?: Message
}
const {
  publicRuntimeConfig: { featureFlags },
} = getConfig()
export const productData: Products[] = [
  {
    title: 'standard',
    displayName: messages.CONF_DNA_OLIGOS_IN_TUBES_standard,
    description: messages.DNA_OLIGO_IN_TUBES_DESC,
    url: `${standardTubeRoute.index()}?product=standard`,
    continueButtonUrl: `/products/molecular-biology-and-functional-genomics/oligos-and-qpcr-probes/custom-predesigned-dna-oligos-and-qpcr-probes`,
  },
  {
    title: 'iscaledna',
    displayName: messages.CONF_DNA_OLIGOS_IN_TUBES_iscaledna,
    description: messages.CONF_ISCALE_DNA_DESC,
    url: `${standardTubeRoute.index()}?product=iscaledna`,
    continueButtonUrl: `/products/molecular-biology-and-functional-genomics/oligos-and-qpcr-probes/custom-predesigned-dna-oligos-and-qpcr-probes`,
  },
  {
    title: 'PROBE',
    displayName: featureFlags.internalAndDualQuenchProbes
      ? messages.CONF_STANDARD_TUBES_PROBE_NEW
      : messages.CONF_DNA_OLIGOS_IN_TUBES_PROBE,
    description: messages.CONF_DUAL_LABELED_PROBES_SUB_HEADING,
    url: `${standardTubeRoute.index()}?product=PROBE`,
    continueButtonUrl: `/products/molecular-biology-and-functional-genomics/oligos-and-qpcr-probes/custom-predesigned-dna-oligos-and-qpcr-probes`,
  },
  {
    title: 'longoligo',
    displayName: messages.CONF_STANDARD_TUBES_longoligo,
    description: messages.DNA_LONG_OLIGO_DESC,
    url: `${standardTubeRoute.index()}?product=longoligo`,
    continueButtonUrl: `/products/molecular-biology-and-functional-genomics/oligos-and-qpcr-probes/custom-predesigned-dna-oligos-and-qpcr-probes`,
  },
  {
    title: 'BEACON',
    displayName: messages.CONF_STANDARD_TUBES_BEACON,
    description: messages.QPCR_PROBES_Desc_molecular_beacons,
    url: `${standardTubeRoute.index()}?product=BEACON`,
    continueButtonUrl: `/products/molecular-biology-and-functional-genomics/oligos-and-qpcr-probes/custom-predesigned-dna-oligos-and-qpcr-probes`,
  },
  {
    title: 'dnaplate',
    displayName: messages.CONF_PRODUCT_DNAPLATE,
    description: messages.DNA_OLIGO_IN_PLATES_DESC,
    url: `${dnaPlatesRoute.index()}?product=dnaplate`,
    continueButtonUrl: `/products/molecular-biology-and-functional-genomics/oligos-and-qpcr-probes/custom-predesigned-dna-oligos-and-qpcr-probes`,
  },
  {
    title: 'duplexplate',
    displayName: messages.CONF_PRODUCT_DUPLEXPLATE,
    description: messages.PC_PRODUCT_DISPLAY_NAME_duplexplate_desc,
    url: `${dnaPlatesRoute.index()}?product=duplexplate`,
    continueButtonUrl: `/products/molecular-biology-and-functional-genomics/oligos-and-qpcr-probes/custom-predesigned-rna-oligos-sirna-duplexes-controls`,
  },
  {
    title: 'rna',
    displayName: messages.CONF_TITLE_rna,
    description: messages.RNA_OLIGO_DESC,
    url: `${standardTubeRoute.index()}?product=rna`,
    continueButtonUrl: `/products/molecular-biology-and-functional-genomics/oligos-and-qpcr-probes/custom-predesigned-rna-oligos-sirna-duplexes-controls`,
  },
  {
    title: 'easyoligo',
    displayName: messages.CONF_DNA_OLIGOS_IN_TUBES_easyoligo,
    description: messages.EASY_OLIGO_DESC,
    url: `${standardTubeRoute.index()}?product=easyoligo`,
    continueButtonUrl: `/products/molecular-biology-and-functional-genomics/oligos-and-qpcr-probes/custom-predesigned-dna-oligos-and-qpcr-probes`,
  },
  {
    title: 'puresimple',
    displayName: messages.CONF_TITLE_puresimple,
    description: messages.PURE_PRIMERS_DESC,
    url: `${standardTubeRoute.index()}?product=puresimple`,
    continueButtonUrl: `/products/molecular-biology-and-functional-genomics/oligos-and-qpcr-probes/custom-predesigned-dna-oligos-and-qpcr-probes`,
  },
  {
    title: 'aqua',
    displayName: messages.CONF_DNA_OLIGOS_IN_TUBES_aqua,
    description: messages.AQUA_Peptides_PRODUCT_AQUA_DESCRIPTION,
    url: `${standardTubeRoute.index()}?product=aqua`,
    continueButtonUrl: `/products/molecular-biology-and-functional-genomics/oligos-and-qpcr-probes/custom-peptides`,
  },
  {
    title: 'wellred',
    displayName: messages.CONF_DNA_OLIGOS_IN_TUBES_wellred,
    description: messages.WELLRED_OLIGO_DESC,
    url: `${standardTubeRoute.index()}?product=wellred`,
    continueButtonUrl: `/products/molecular-biology-and-functional-genomics/oligos-and-qpcr-probes/custom-predesigned-dna-oligos-and-qpcr-probes`,
  },
  {
    title: 'cpeptide',
    displayName: messages.PC_PRODUCT_DISPLAY_NAME_cpeptide,
    description: messages.PC_PRODUCT_DISPLAY_NAME_cpeptide_desc,
    url: `${standardTubeRoute.index()}?product=cpeptide`,
    continueButtonUrl: `/products/molecular-biology-and-functional-genomics/oligos-and-qpcr-probes/custom-peptides`,
  },
  {
    title: 'fastduplex',
    displayName: messages.PC_PRODUCT_DISPLAY_NAME_fastduplex,
    description: messages.PC_PRODUCT_DISPLAY_NAME_fastduplex_desc,
    url: `${fastDuplexOligosRoute.index()}?product=fastduplex`,
    continueButtonUrl: `/products/molecular-biology-and-functional-genomics/oligos-and-qpcr-probes/custom-predesigned-rna-oligos-sirna-duplexes-controls`,
  },
  {
    title: 'duplex',
    displayName: messages.PC_PRODUCT_DISPLAY_NAME_duplex,
    description: messages.PC_PRODUCT_DISPLAY_NAME_duplex_desc,
    url: `${fastDuplexOligosRoute.index()}?product=duplex`,
    continueButtonUrl: `/products/molecular-biology-and-functional-genomics/oligos-and-qpcr-probes/custom-predesigned-rna-oligos-sirna-duplexes-controls`,
  },
  {
    title: 'mirna',
    displayName: messages.CONF_TITLE_mirna,
    description: messages.PC_PRODUCT_DISPLAY_NAME_duplex_desc,
    url: `${fastDuplexOligosRoute.index()}?product=mirna`,
    continueButtonUrl: `/products/molecular-biology-and-functional-genomics/oligos-and-qpcr-probes/custom-predesigned-rna-oligos-sirna-duplexes-controls`,
  },
  {
    title: 'lightcycle',
    displayName: featureFlags.internalAndDualQuenchProbes
      ? messages.CONF_STANDARD_TUBES_PROBE_NEW
      : messages.CONF_DNA_OLIGOS_IN_TUBES_PROBE,
    description: messages.DNA_OLIGO_IN_PLATES_DESC,
    url: `${fastDuplexOligosRoute.index()}?product=lightcycle`,
    continueButtonUrl: `/products/molecular-biology-and-functional-genomics/oligos-and-qpcr-probes/custom-predesigned-dna-oligos-and-qpcr-probes`,
  },
  {
    title: 'mpdsirna',
    displayName: messages.PC_PRODUCT_DISPLAY_NAME_mpdsirna,
    description: messages.PC_PRODUCT_DISPLAY_NAME_mpdsirna_desc,
    url: `${sirnaRoute.index()}`,
    continueButtonUrl: `/products/molecular-biology-and-functional-genomics/oligos-and-qpcr-probes/custom-predesigned-rna-oligos-sirna-duplexes-controls`,
  },
  {
    title: 'KiCqStartPrimers',
    displayName: messages.QPCR_PROBES_kICqStart_primers,
    description: messages.QPCR_PROBES_Desc_kICqStart_primers,
    url: `${kicqstartPrimersRoute.index()}`,
    continueButtonUrl: `/products/molecular-biology-and-functional-genomics/oligos-and-qpcr-probes/custom-predesigned-dna-oligos-and-qpcr-probes`,
  },
  {
    title: 'kicqstartPrimers',
    displayName: messages.QPCR_PROBES_kICqStart_primers,
    description: messages.QPCR_PROBES_Desc_kICqStart_primers,
    url: `${kicqstartPrimersRoute.index()}`,
    continueButtonUrl: `/products/molecular-biology-and-functional-genomics/oligos-and-qpcr-probes/custom-predesigned-dna-oligos-and-qpcr-probes`,
  },
  {
    title: 'KicqStartArrayGateWay',
    displayName: messages.QPCR_PROBES_kICqStart_primers_gene_arrays,
    description: messages.QPCR_PROBES_Desc_kICqStart_primers_gene_arrays,
    url: `${kicqstartGeneArrayRoute.index()}`,
    continueButtonUrl: `/products/molecular-biology-and-functional-genomics/oligos-and-qpcr-probes/custom-predesigned-dna-oligos-and-qpcr-probes`,
  },
  {
    title: 'kicqstartgenearrays',
    displayName: messages.QPCR_PROBES_kICqStart_primers_gene_arrays,
    description: messages.QPCR_PROBES_Desc_kICqStart_primers_gene_arrays,
    url: `${kicqstartGeneArrayRoute.index()}`,
    continueButtonUrl: `/products/molecular-biology-and-functional-genomics/oligos-and-qpcr-probes/custom-predesigned-dna-oligos-and-qpcr-probes`,
  },
  {
    title: 'kicqstartProbe',
    displayName: {
      id: 'SEMICONF_TITLE_KICQSTART',
      defaultMessage: 'KiCqStart Probes',
    },
    url: `${kicqStartRoute.index()}`,
    continueButtonUrl: `/products/molecular-biology-and-functional-genomics/oligos-and-qpcr-probes/custom-predesigned-dna-oligos-and-qpcr-probes`,
  },
  {
    title: 'Kicqstart',
    displayName: {
      id: 'SEMICONF_TITLE_KICQSTART',
      defaultMessage: 'KiCqStart Probes',
    },
    url: `${kicqStartRoute.index()}`,
    continueButtonUrl: `/products/molecular-biology-and-functional-genomics/oligos-and-qpcr-probes/custom-predesigned-dna-oligos-and-qpcr-probes`,
  },
  {
    title: 'sirna',
    displayName: messages.PC_PRODUCT_DISPLAY_NAME_mpdsirna,
    description: messages.PC_PRODUCT_DISPLAY_NAME_mpdsirna_desc,
    url: `${sirnaRoute.index()}`,
    continueButtonUrl: `/products/molecular-biology-and-functional-genomics/oligos-and-qpcr-probes/custom-predesigned-rna-oligos-sirna-duplexes-controls`,
  },
  {
    title: 'orf',
    displayName: { id: 'SEMI_CONF_PRODUCT_ORF', defaultMessage: 'ORF' },
    description: { id: 'SEMI_CONF_PRODUCT_ORF', defaultMessage: 'ORF' },
    url: `${orfRoute.index()}`,
    continueButtonUrl: `/products/molecular-biology-and-functional-genomics/gene-editing-and-functional-genomics/rnai-single-clones`,
  },
  {
    title: 'shrna',
    displayName: {
      id: 'SEMICONF_TITLE_PREDESIGNED_shrna',
      defaultMessage: 'Predesigned shRNA',
    },
    description: {
      id: 'SEMICONF_TITLE_PREDESIGNED_shrna',
      defaultMessage: 'Predesigned shRNA',
    },
    url: `${shrnaRoute.index()}`,
    continueButtonUrl: `/products/molecular-biology-and-functional-genomics/gene-editing-and-functional-genomics/rnai-single-clones`,
  },
  {
    title: 'crisprgrna',
    displayName: messages.CONF_CRISPR_gRNA_HEADER_crisprgrna,
    description: messages.CONF_CRISPR_gRNA_HEADER_crisprgrna,
    url: `${crisprgrnaRoute.index()}`,
    continueButtonUrl: `/products/molecular-biology-and-functional-genomics/gene-editing-and-functional-genomics/crispr-gene-editing`,
  },
  {
    title: 'antisera',
    displayName: messages.CONF_ANTISERA,
    description: messages.CONF_ANTISERA,
    url: `${antiseraRoute.index()}`,
    continueButtonUrl: `/products/molecular-biology-and-functional-genomics/oligos-and-qpcr-probes/custom-peptides`,
  },
  {
    title: 'simpleantisera',
    displayName: messages.CONF_SIMPLE_ANTISERA,
    description: messages.CONF_SIMPLE_ANTISERA,
    url: `${simpleantiseraRoute.index()}`,
    continueButtonUrl: `/products/molecular-biology-and-functional-genomics/oligos-and-qpcr-probes/custom-peptides`,
  },
  {
    title: 'ngso',
    displayName: {
      id: 'CONF_NEXT_GEN_SEQUENCING_OLIGOS_NGSO',
      defaultMessage: 'Next-Gen Sequencing Oligos',
    },
    description: {
      id: 'CONF_NEXT_GEN_SEQUENCING_OLIGOS_NGSO',
      defaultMessage: 'Next-Gen Sequencing Oligos',
    },
    url: `${NgsoRoute.index()}`,
    continueButtonUrl: `/products/molecular-biology-and-functional-genomics/oligos-and-qpcr-probes/custom-predesigned-dna-oligos-and-qpcr-probes`,
  },
]

export const crisprgrnaProductData: Products[] = [
  {
    title: '',
    displayName: messages.COMPANION_PRODUCT_TRACRRNAMOD_crisprgrna,
    description: messages.COMPANION_PRODUCT_TRACRRNAMOD_DESC_crisprgrna,
    url: '',
    continueButtonUrl: '',
    productCompany: messages.CONF_COMPANY_SIGMA,
  },
  {
    title: '',
    displayName: messages.COMPANION_PRODUCT_CAS9PROT_crisprgrna,
    description: messages.COMPANION_PRODUCT_CAS9_PROTEIN_DESC_crisprgrna,
    url: '',
    continueButtonUrl: '',
    productCompany: messages.CONF_COMPANY_SIGMA,
  },
  {
    title: '',
    displayName: messages.COMPANION_PRODUCT_ESPCAS9PRO_crisprgrna,
    description: messages.COMPANION_PRODUCT_ESPCAS9_PROTEIN_DESC_crisprgrna,
    url: '',
    continueButtonUrl: '',
    productCompany: messages.CONF_COMPANY_SIGMA,
  },
]

export const customCrisprProductData: Products[] = [
  {
    title: 'CAS9PROT',
    displayName: messages.COMPANION_PRODUCT_CAS9PROT_crisprgrna,
    description: messages.COMPANION_PRODUCT_CAS9_PROTEIN_DESC_crisprgrna,
    url: 'product/SIGMA/CAS9PROT?context=product',
    continueButtonUrl: '',
    productCompany: messages.CONF_COMPANY_SIGMA,
  },
  {
    title: 'ESPCAS9PRO',
    displayName: messages.COMPANION_PRODUCT_ESPCAS9PRO_crisprgrna,
    description: messages.COMPANION_PRODUCT_ESPCAS9_PROTEIN_DESC_crisprgrna,
    url: 'product/SIGMA/ESPCAS9PRO?context=product',
    continueButtonUrl: '',
    productCompany: messages.CONF_COMPANY_SIGMA,
  },
  {
    title: 'TRACRRNAMOD',
    displayName: messages.COMPANION_PRODUCT_TRACRRNAMOD_crisprgrna,
    description: messages.COMPANION_PRODUCT_TRACRRNAMOD_DESC_crisprgrna,
    url: 'product/SIGMA/tracrrnamod?context=product',
    continueButtonUrl: '',
    productCompany: messages.CONF_COMPANY_SIGMA,
  },
  {
    title: 'FNCAS9TRACR',
    displayName: messages.COMPANION_PRODUCT_FNCAS9TRACR_crisprgrna,
    description: messages.COMPANION_PRODUCT_FNCAS9TRACR_DESC_crisprgrna,
    url: 'product/SIGMA/fncas9tracr?context=product',
    continueButtonUrl: '',
    productCompany: messages.CONF_COMPANY_SIGMA,
  },
  {
    title: 'FNCAS9PROT',
    displayName: messages.COMPANION_PRODUCT_FNCAS9PROT_crisprgrna,
    description: messages.COMPANION_PRODUCT_FNCAS9PROT_PROTEIN_DESC_crisprgrna,
    url: 'product/SIGMA/fncas9prot?context=product',
    continueButtonUrl: '',
    productCompany: messages.CONF_COMPANY_SIGMA,
  },
  {
    title: 'ModifiedFNCAS9TRACR',
    displayName: messages.COMPANION_PRODUCT_MODIFIED_FNCAS9TRACR_crisprgrna,
    description:
      messages.COMPANION_PRODUCT_MODIFIED_FNCAS9TRACR_DESC_crisprgrna,
    url: 'https://www.sigmaaldrich.com/life-science/functional-genomics-and-rnai/learning-center/custom-tracrrna-quotation-request.html',
    continueButtonUrl: '',
    productCompany: messages.CONF_COMPANY_SIGMA,
  },
  {
    title: 'TRACRRNA05N',
    displayName: messages.COMPANION_PRODUCT_TRACRRNA05N_crisprgrna,
    description: messages.COMPANION_PRODUCT_TRACRRNA05N_DESC_crisprgrna,
    url: 'product/SIGMA/tracrrna05n?context=product',
    continueButtonUrl: '',
    productCompany: messages.CONF_COMPANY_SIGMA,
  },
]
